import { useState, useEffect } from 'react'
import { nonprofitsApi } from '../../services/api/nonprofits'

export type NonprofitRequestQueryParams = {
  nonprofitCategoryId: null | number
  pageSize: number
  searchText: string
  pageIndex: number
}

export const useNonProfitPage = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [nonprofits, setNonprofits] = useState([])
  const [searchText, setSearchText] = useState<string>('')
  const [query, setQuery] = useState<NonprofitRequestQueryParams>({
    nonprofitCategoryId: null,
    pageSize: 1,
    searchText: '',
    pageIndex: 1,
  })
  const [categories, setCategories] = useState([])
  const [needApply] = useState<boolean>(false)
  const [firstRender, setFirstRender] = useState<boolean>(true)
  const [isFilterCollapsed, setIsFilterCollapsed] = useState<boolean>(false)

  //Get Categories
  useEffect(() => {
    const abortController = new AbortController()
    const fetchCategories = async () => {
      try {
        const categories = await nonprofitsApi.categories()
        setCategories([...categories] as any)
      } catch (error) {}
    }

    fetchCategories()
    return () => {
      abortController.abort()
    }
  }, [])

  return {
    loading,
    query,
    needApply,
    firstRender,
    categories,
    nonprofits,
    isFilterCollapsed,
    searchText,

    setLoading,
    setSearchText,
    setQuery,
    setNonprofits,
    setFirstRender,
    setIsFilterCollapsed,
  }
}
